import React from 'react';
import { NavigationItem } from '@client/components/navigation/NavigationItem';

const authenticatedRoutes = [
  {
    name: 'Hitta insamlingar',
    path: '/insamlingar/',
  },
  {
    name: 'Frågor och svar',
    path: '/hjalp/',
  },
  {
    name: 'Mina insamlingar',
    path: '/mitt-konto/mina-insamlingar/',
  },
  {
    name: 'Skapa insamling',
    path: '/skapa/insamling/',
  },
];

export const AuthenticatedRoutes = () => {
  return (
    <>
      {authenticatedRoutes?.map((navItem) => (
        <NavigationItem
          key={navItem?.path}
          path={navItem?.path}
          name={navItem?.name}
        />
      ))}
    </>
  );
};
